// extracted by mini-css-extract-plugin
module.exports = {"defaultTrack":"DefaultTrack-module__defaultTrack___4OAy4"};